import React from 'react';
import { Box, Typography, Button, SvgIcon, useTheme } from '@mui/material';
import { IconPlus } from '@tabler/icons';
import IconEmptyState from '../../../assets/images/icons/empty-state.png';
import WithPermission from '../WithPermission/WithPermission';

const EmptyState = ({
  title = 'No data available',
  description,
  buttonText,
  buttonAction,
  imageHeight = 120,
  height = 380,
  showAction = true,
  permission,
  /** Extra gate (e.g. Yangon product actions). Defaults to true. */
  and = true,
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        height,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        p: 4,
        textAlign: 'center',
        color: theme.palette.text.secondary,
      }}
    >
      <img 
          src={IconEmptyState} 
          alt="Empty state" 
          style={{ 
            width: 'auto', 
            height: imageHeight, 
            marginBottom: theme.spacing(2),
            opacity: 0.6
          }} 
        />

      <Typography variant="h6" gutterBottom sx={{ color: theme.palette.text.primary }}>
        {title}
      </Typography>

      {description && (
        <Typography variant="body2" sx={{ maxWidth: 400, mb: 2 }}>
          {description}
        </Typography>
      )}

      {showAction && buttonText && buttonAction && (
        <WithPermission permission={permission} and={and}>
        <Button
          variant="contained"
          onClick={buttonAction}
          sx={{ mt: 2 }}
          startIcon={<IconPlus size={16} />}
        >
          {buttonText}
        </Button>
        </WithPermission>
      )}
    </Box>
  );
};

export default EmptyState;
